<template>
  <!-- 面包屑 -->
	<div class="ls-flex-col-center">
		<div class="max-width ls-flex ls-jc-space-between p-t-20">
			<ul class="el-breadcrumb ls-flex ls-al-center">
				<li class="m-r-10">
					<img src="../assets/image/home.png" style="width: 21px;height: 20px;" alt="">
				</li>
				<li class="fs-16">{{$cetihuan.dcwz[$store.state.lang]}}：</li>
				<li><router-link class="fs-16" to="/">{{$cetihuan.home[$store.state.lang]}}</router-link></li>
				<template v-if="sousuo">
					<span>&ensp; &gt; &ensp;</span>
					<p class="f-3546A0 fs-16" @click="findRoute(item)">{{ titleDetail }}</p>
				</template>
				<li v-if="title" v-for="(item, index) in lists" :key="index">
					<template v-if="index == 0">
						<span v-if="item.meta[$store.state.lang]">&ensp; &gt; &ensp;</span>
						<p class="fs-16" @click="findRoute(item)">{{ item.meta[$store.state.lang] }}</p>
					</template>
					<template v-if="title && index == 0">
						<span>&ensp; &gt; &ensp;</span>
						<p class="f-3546A0 fs-16" @click="findRoute(item)">{{ title }}</p>
					</template>
					<template v-if="titleDetail && index == 0">
						<span>&ensp; &gt; &ensp;</span>
						<p class="f-3546A0 fs-16" @click="findRoute(item)">{{ titleDetail }}</p>
					</template>
				</li>
				<li v-else>
					<template>
						<span v-if="item.meta[$store.state.lang]">&ensp; &gt; &ensp;</span>
						<p :class="index == 1 && !title ? 'f-3546A0 fs-16' : 'fs-16'" @click="findRoute(item)">{{ item.meta[$store.state.lang] }}</p>
					</template>
					<template v-if="caseDetailType && index == 0 ">
						<span>&ensp; &gt; &ensp;</span>
						<router-link class="fs-16" :to="newsPath">{{ $cetihuan[caseDetai][$store.state.lang] }}</router-link>
					</template>
					<template v-if="newsDetailType && index == 0 ">
						<span>&ensp; &gt; &ensp;</span>
						<router-link class="fs-16" :to="newsPath">{{ $cetihuan[newsDetail][$store.state.lang] }}</router-link>
					</template>
				</li>
			</ul>
			<div v-if="index == 1 || (index == 6 && detail == 2) || (index == 3 && detail == 2) || index == 5" class="ls-flex children">
				<ul>
					<li v-if="item.path != '/ProjectCase/Detail' && item.path != '/News/Detail'" v-for="(item, index) in children" :key="index" :class="classes(item)">
						<router-link :to="item.path">
							<span class="fs-22" >{{item.meta[$store.state.lang]}}</span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import routes from "@/router/routes";
export default {
	props: ["index",'type','detailType','ss','detail','caseDetailType','newsDetailType'],
	data() {
		return {
			lists: routes,
			children:[],
			name:'',
			title:'',
			titleDetail:'',
			sousuo:'',
			off:1,
			newsPath:'',
			newsDetail:'',
			caseDetai:''
		};
	},
	//创建时获取路由信息
	created() {
		this.name = this.$route.name;
		this.lists = this.$route.matched;
		this.children = routes[this.index].children;
		if (this.newsDetailType == '公司新闻') {
			this.newsPath = '/News/CompanyNews';
			this.newsDetail = 'gsxw';
		} else if (this.newsDetailType == '信息公开') {
			this.newsPath = '/News/Information';
			this.newsDetail = 'xxgk';
		} else if (this.newsDetailType == '行业动态') {
			this.newsPath = '/News/Dynamics';
			this.newsDetail = 'hydt';
		} else if (this.newsDetailType == '资料查看') {
			this.newsPath = '/News/leadership';
			this.newsDetail = 'zlxz';
		}
		if (this.caseDetailType == '住宅建筑') {
			this.newsPath = '/ProjectCase/Housing';
			this.caseDetai = 'zzjz';
		} else if (this.caseDetailType == '公共建筑') {
			this.newsPath = '/ProjectCase/Public';
			this.caseDetai = 'ggjz';
		} else if (this.caseDetailType == '工业建筑') {
			this.newsPath = '/ProjectCase/Industrial';
			this.caseDetai = 'gyjz';
		} else if (this.caseDetailType == '商业建筑') {
			this.newsPath = '/ProjectCase/Commercial';
			this.caseDetai = 'syjz';
		} else if (this.caseDetailType == '国外建筑') {
			this.newsPath = '/ProjectCase/Foreign';
			this.caseDetai = 'gwjz';
		}
	},
	//监听路由变化
	watch: {
		$route: {
			handler: function (val, oldVal) {
				this.lists = val.matched;
				this.name = val.name;
			},
			deep: true,
		},
		type:{
			handler: function (val, oldVal) {
				this.title = val;
			},
		},
		detailType:{
			handler: function (val, oldVal) {
				this.titleDetail = val;
			},
		},
		ss:{
			handler: function (val, oldVal) {
				this.sousuo = val;
			},
		},
		detail:{
			handler: function (val, oldVal) {
				this.off = val;
				console.log(val);
			},
		}
	},
	//计算
	computed: {},
	methods: {
		// 判断是否有子路由
		classes(el) {
			//判断子路由是否有匹配项
			if (el.name == this.name) {
				return el.name == this.name ? "active" : "";
			} else if (el.children) {
				return el.children.some((item) => {
					if (item.children) {
						return item.children.some((i) => {
							return i.name === this.name;
						});
					} else {
						return item.name === this.name;
					}
				})
				? "active"
				: "";
			} else {
				return el.name === this.name ? "active" : "";
			}
		},
		findRoute(path) {
			if (path.meta[this.$store.state.lang] != '详情') {
				routes.forEach((item, index) => {
					if (item.meta[this.$store.state.lang] == path.meta[this.$store.state.lang]) {
						if (item.children && item.children.length > 1) {
							if (item.children[0].children) {
								this.$router.push(item.children[0].children[0].path)
							} else {
								this.$router.push(item.children[0].path)
							}
						} else {
								this.$router.push(item.path);
						}
					} else if (item.children && item.children.length > 1) {
						item.children.forEach((i) => {
							if (i.children) {
								i.children.forEach((j) => {
									if (j.meta[this.$store.state.lang] == path.meta[this.$store.state.lang]) {
										if (j.children) {
											this.$router.push(j.children[0].path)
										} else {
										  this.$router.push(j.path);
										}
									}
								})
							} else if (i.meta[this.$store.state.lang] == path.meta[this.$store.state.lang]) {
								if (i.children) {
									this.$router.push(i.children[0].path)
								} else if (i.meta.type != 'detail') {
									this.$router.push(i.path)
								}
							}
						})
					}
				});
			}
		}
	},
};
</script>

<style lang="scss">
.el-breadcrumb {
	@media screen and (max-width: 768px) {
		width: 100% !important;
		display: none;
	}
	li {
		display: flex;
		cursor: pointer;

		a {
			display: inline;
			color: #000000;

			span {
				margin-right: 0.625rem;
			}
		}
	}
}
.children{
	ul {
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-around;
		height: 100%;
	
		.active {
	
			a {
				color:#fff;
				background-color: #3546A0;
			}
		}
	
		li {
			list-style: none;
			width: max-content;
			height: 100%;
			font-size: 1.375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333;
			line-height: 26px;
			display: flex;
			align-items: center;
			justify-content: space-around;
	
			a {
				width: max-content;
				border-radius: 1.5625rem;
				font-size: 1.375rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #333;
				display: block;
				border-bottom: transparent 2px solid;
				text-align: center;
				padding: 0.5rem 1rem;
			}
			.lang{
				width: 3rem;
				height: 1.2rem;
				background: #001066;
				border-radius: 1.2rem;
				font-size: 0.7rem;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}
</style>